import { render, staticRenderFns } from "./OrdersPageFlagged.vue?vue&type=template&id=93b54974&scoped=true"
import script from "./OrdersPageFlagged.vue?vue&type=script&lang=js"
export * from "./OrdersPageFlagged.vue?vue&type=script&lang=js"
import style0 from "./OrdersPageFlagged.vue?vue&type=style&index=0&id=93b54974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b54974",
  null
  
)

export default component.exports